import { animate, style, transition } from '@angular/animations';

export const moveRightIf = [
  transition(':enter', [
    style({ transform: 'translateX(calc(-100% - 20px))' }),
    animate('.2s ease', style({ transform: 'translateX(0px)' })),
  ]),
  transition(':leave', [
    style({ transform: 'translateX(0px)' }),
    animate('.2s ease', style({ transform: 'translateX(calc(-100% - 20px))' })),
  ]),
];
